export const SCREEN_HEIGHT = {
  SMALL: 600,
  MEDIUM: 937,
  LARGE: 1200,
  // Add more sizes as needed
};
